<div
  *ngIf="!COOKIES_ACCEPTED"
  class="cookie-law-container"
>
  <div
    class="cookie-law-content-container"
    [ngClass]="{'dark-back': COOKIES_SHOW_DETAIL}"
  >
    <div class="cookie-law-content">

      <div class="cookie-law-content-main">
        <p class="cookie-law-message">
          Utilizamos cookies propias y de terceros para fines analíticos. Clic <span
            class="cookie-law-link"
            (click)="_showModalPoliticaCookies=true"
          >AQUÍ</span> para más información. Puede aceptar todas las cookies pulsando el botón "Aceptar", o bien
          configurarlas o rechazar su uso clicando <span
            class="cookie-law-link"
            (click)="COOKIES_SHOW_DETAIL = !COOKIES_SHOW_DETAIL"
          >AQUÍ</span>.
        </p>

        <button
          class="cookie-law-btn"
          (click)="onCookiesAccepted()"
        >{{ COOKIES_SHOW_DETAIL ? 'Guardar configuración de cookies' : 'Aceptar cookies' }}</button>
      </div>

      <div
        *ngIf="COOKIES_SHOW_DETAIL"
        class="cookie-law-detail"
      >
        <h2 class="cookie-law-detail-title">DECLARACIÓN DE COOKIES</h2>
        <div class="cookie-law-detail-cooser">
          <div class="cookie-law-detail-type">
            <ul>
              <li
                *ngFor="let cookieItem of _cookiesFiltered"
                [ngClass]="{'selected': cookieItem.type === TYPE_SELECTED}"
                (click)="onTypeSelected(cookieItem.type)"
              >
                <input
                  type="checkbox"
                  class="cookie-law-detail-check"
                  [checked]="hasCookiesChecked(cookieItem.type)"
                  (change)="onCheckChecked(cookieItem.type)"
                  [disabled]="disableCheck(cookieItem.cookies)"
                >
                <span class="cookie-law-detail-checkmark"></span>
                <span class="cookie-law-detail-check-text">
                  {{ cookieItem.type + ' [' + cookieItem.cookies.length + ']'}}
                </span>
              </li>
            </ul>
          </div>
          <div class="cookie-law-detail-table">
            <ng-container *ngTemplateOutlet="tableCookies; context: {
              list: filterCookiesList(TYPE_SELECTED),
              showChecks: true
            }"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODAL -->
<sacyr-modal
  [setTemplateRef]="modal_content"
  [showModal]="showModal()"
  (closeModal)="closeModal()"
></sacyr-modal>

<ng-template #modal_content>

  <ng-container *ngIf="_showModalPoliticaCookies">
    <h1>Política de cookies</h1>
    <div>
      <p>
        <b>¿Qué es una cookie?</b><br />
        Las cookies constituyen una herramienta empleada por los servidores web para almacenar y recuperar
        información acerca de sus visitantes. No es más que un identificador único en forma de fichero de texto
        que algunos servidores remiten al dispositivo del usuario, para registrar información acerca de lo que
        hemos estado haciendo por sus páginas web, permitiendo así mejorar la calidad y seguridad de la página
        web. Poseen una fecha de caducidad, que puede oscilar desde el tiempo que dure la sesión, hasta una fecha
        futura especificada a partir de la cual dejan de ser operativas.
      </p>

      <p>
        <b>Utilidad de las cookies en este Sitio Web</b><br />
        En este Sitio Web se utilizan cookies para facilitar la navegación por el portal, por motivos de seguridad
        y para obtener una mayor eficacia y personalización de los servicios ofrecidos a los usuarios.
      </p>

      <p>
        <b>Cookies propias</b><br />
        Las hay estrictamente necesarias como, por ejemplo, aquellas que sirvan para una correcta navegación y
        cookies analíticas de primera parte para recopilar datos estadísticos de la actividad.
      </p>

      <ng-container *ngTemplateOutlet="tableCookies; context: {
        list: filterCookiesList(null, PROVIDER_SELF),
        showChecks: false
      }"></ng-container>

      <p>
        <b>Cómo administrar las cookies instaladas en su dispositivo</b><br />
        Puede permitir, bloquear o eliminar las cookies instaladas en su equipo o dispositivo mediante la
        configuración de las opciones de su navegador de Internet.<br />
        <br />
        Estos ajustes suelen encontrarse en las “opciones” o “preferencias” de su navegador. Le orientamos a
        continuación de los pasos para acceder al menú de configuración de cookies en los siguientes navegadores
        principales:
      </p>
      <ul>
        <li>
          <b>Internet Explorer</b>: Herramientas -> Opciones de Internet -> Privacidad -> Configuración. Para más
          información, puede consultar el soporte de Microsoft o la Ayuda del navegador.
        </li>
        <li>
          <b>Firefox</b>: Herramientas -> Opciones -> Privacidad -> Historial -> Configuración Personalizada. Para
          más información, puede consultar el soporte de Mozilla o la Ayuda del navegador.
        </li>
        <li>
          <b>Chrome</b>: Configuración -> Mostrar opciones avanzadas -> Privacidad -> Configuración de contenido.
          Para más
          información, puede consultar el soporte de Google o la Ayuda del navegador.
        </li>
        <li>
          <b>Safari</b>: Preferencias -> Seguridad. Para más información, puede consultar el soporte de Apple o la
          Ayuda del navegador.
        </li>
      </ul>
      <p>
        Si rechaza la instalación de cookies podrá seguir usando el sitio web, aunque el uso de algunos de sus
        servicios podrá ser limitado y por tanto su experiencia en nuestro sitio web resultar menos satisfactoria.
      </p>

      <p>
        <b>Revocar el consentimiento prestado</b><br />
        Si quisiese retirar en cualquier momento su consentimiento relacionado con la presente Política de
        Cookies, deberá eliminar las cookies almacenadas a través de los ajustes y configuraciones de su navegador
        de Internet.
      </p>

      <p>
        <b>Ejercicio de derechos</b><br />
        En todo momento podrá ejercer sus derechos de acceso, rectificación, supresión, oposición, limitación de
        la finalidad y portabilidad con respecto a los datos personales que haya facilitado, a través del correo
        electrónico protecciondedatos@sacyr.com, aportando copia de tu DNI o documento equivalente, e
        identificándote como usuario de este sitio web.<br />
        <br />
        En caso de considerar vulnerados sus derechos de privacidad podrá dirigirse al Delegado de Protección de
        Datos de SACYR (dpo@sacyr.com) o, si este no atendiese su requerimiento, podrá interponer una reclamación
        ante la Agencia Española de Protección de Datos (www.aepd.es).
      </p>

      <p>
        <b>Información adicional</b><br />
        Si precisa consultar información adicional sobre algún aspecto específico del tratamiento de sus datos en
        el marco del uso del presente sitio web puede contactar en todo momento con dpo@sacyr.com
      </p>

    </div>
  </ng-container>

</ng-template>

<ng-template
  #tableCookies
  let-list="list"
>
  <div class="cookie-law-table-container">
    <table class="cookie-law-table">
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Proveedor</th>
          <th>Caducidad</th>
          <th>Finalidad</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let cookie of list">
          <tr>
            <td>{{ cookie.name }}</td>
            <td>{{ cookie.provider }}</td>
            <td>{{ cookie.expiration }}</td>
            <td>{{ cookie.purpose }}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</ng-template>
